module.exports = __webpack_public_path__ + "static/media/OrdemServico7.63860957.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancOrdemServicos/OrdemServico7.png
// module id = 1771
// module chunks = 0